export default function HowDoesItWork() {
    return{
        title: 'How does it work',
        paragraphs: ['<div>Term life insurance provides a guaranteed death benefit on the life of the insured for a specified period of time depending on the product duration selected. With a level term life insurance contract, premium rates are also guaranteed to remain constant throughout the policy term. Premiums are often lower than comparable amounts of permanent insurance coverage as there is no potential for cash value or death benefit growth in a term life insurance contract. If the insured lives beyond the specified policy duration, no death benefit will be paid.</div>'
    ],
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/term/HowDoesItWorkData.js